"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = require("events");

var _seamlessImmutable = _interopRequireDefault(require("seamless-immutable"));

var _seamlessImmutablePatch = _interopRequireDefault(require("seamless-immutable-patch"));

var _rfc = _interopRequireDefault(require("rfc6902"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var seamless = _seamlessImmutable.default.from,
    set = _seamlessImmutable.default.set,
    merge = _seamlessImmutable.default.merge,
    setIn = _seamlessImmutable.default.setIn;

var getNewSampleRefId = function getNewSampleRefId() {
  return "s" + Math.random().toString(36).slice(-8);
};

var defaultCollaborationServer = "https://collaboration.universaldatatool.com";

var CollaborativeDatasetManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(CollaborativeDatasetManager, _EventEmitter);

  var _super = _createSuper(CollaborativeDatasetManager);

  // TODO we should cache samples in the future to allow preloading
  // currentlyLoadedSampleMap = {}
  // currentlyLoadedSampleIds = []
  function CollaborativeDatasetManager() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        serverUrl = _ref.serverUrl;

    _classCallCheck(this, CollaborativeDatasetManager);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "udtJSON", null);

    _defineProperty(_assertThisInitialized(_this), "type", "collaborative-session");

    _defineProperty(_assertThisInitialized(_this), "sessionId", null);

    _defineProperty(_assertThisInitialized(_this), "summaryVersion", null);

    _defineProperty(_assertThisInitialized(_this), "ds", null);

    _defineProperty(_assertThisInitialized(_this), "pollingInterval", 1000);

    _defineProperty(_assertThisInitialized(_this), "requestTimeout", 120000);

    _defineProperty(_assertThisInitialized(_this), "createNewSession", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ds) {
        var endpoint, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = "".concat(_this.url, "/api/session");
                _context.next = 3;
                return _axios.default.post(endpoint, {
                  udt: ds
                }, {
                  timeout: _this.requestTimeout
                }).catch(function (e) {
                  throw new Error("Creating collaborative session failed (via POST \"".concat(endpoint, "\")\n\n").concat(e.toString()));
                }).then(function (r) {
                  return r.data;
                }).catch(function (e) {
                  throw new Error("Couldn't parse response from collaborative server: ".concat(e.toString()));
                });

              case 3:
                res = _context.sent;
                _this.sessionId = res.short_id;
                _this.summaryVersion = res.summary_version;
                _this.diffPollingTimeout = setTimeout(_this.pollDiffs, _this.pollingInterval);
                _context.next = 9;
                return _this.getSummary();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadSession", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sessionId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.sessionId = sessionId;
                console.log("joining session \"".concat(_this.sessionId, "\""));
                _context2.next = 4;
                return _this.getSummary();

              case 4:
                clearTimeout(_this.diffPollingTimeout);
                _this.diffPollingTimeout = setTimeout(_this.pollDiffs, _this.pollingInterval);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "pollDiffs", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$axios$get$then, patch, latestVersion, patchWithoutSampleUpdates;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this.sessionId && _this.ds)) {
                _context3.next = 9;
                break;
              }

              _context3.next = 3;
              return _axios.default.get("".concat(_this.url, "/api/session/").concat(_this.sessionId, "/diffs?since=").concat(_this.summaryVersion), {
                timeout: _this.requestTimeout
              }).then(function (r) {
                return r.data;
              });

            case 3:
              _yield$axios$get$then = _context3.sent;
              patch = _yield$axios$get$then.patch;
              latestVersion = _yield$axios$get$then.latestVersion;

              if (latestVersion !== _this.summaryVersion) {
                // Update summary object, but not samples
                patchWithoutSampleUpdates = patch.filter(function (p) {
                  return !p.path.startsWith("/samples");
                });
                _this.ds = (0, _seamlessImmutablePatch.default)(_this.ds, patchWithoutSampleUpdates);
                _this.summaryVersion = latestVersion;

                _this.emit("summary-changed");
              }

              _context3.next = 10;
              break;

            case 9:
              _this.getSummary();

            case 10:
              if (_this.sessionId) {
                _this.diffPollingTimeout = setTimeout(_this.pollDiffs, _this.pollingInterval);
              }

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "isReady", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", Boolean(_this.sessionId) && Boolean(_this.summary));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "getSummary", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var res, summaryVersion, summary, name, iface;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this.ds) {
                _context5.next = 7;
                break;
              }

              _context5.next = 3;
              return _axios.default.get("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                timeout: _this.requestTimeout
              }).then(function (r) {
                return r.data;
              });

            case 3:
              res = _context5.sent;
              summaryVersion = res.summaryVersion, summary = res.summary, name = res.name, iface = res.interface;
              _this.ds = seamless({
                summary: summary,
                interface: iface,
                name: name
              });
              _this.summaryVersion = summaryVersion;

            case 7:
              return _context5.abrupt("return", _this.ds.summary);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "getDatasetProperty", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(key) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this.ds) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return _this.getSummary();

              case 3:
                return _context6.abrupt("return", _this.ds[key]);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setDatasetProperty", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(key, newValue) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // TODO
                _this.ds = setIn(_this.ds, [key], newValue);
                _context7.next = 3;
                return _axios.default.patch("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                  patch: [{
                    op: "replace",
                    path: "/".concat(key),
                    value: newValue
                  }]
                }, {
                  timeout: _this.requestTimeout
                });

              case 3:
                _this.emit("dataset-property-changed", {
                  key: key
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x4, _x5) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSampleByIndex", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(index) {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _axios.default.get("".concat(_this.url, "/api/session/").concat(_this.sessionId, "/sample/").concat(index), {
                  timeout: _this.requestTimeout
                }).then(function (r) {
                  return r.data;
                });

              case 2:
                res = _context8.sent;
                return _context8.abrupt("return", res);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x6) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSample", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(sampleRefId) {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _axios.default.get("".concat(_this.url, "/api/session/").concat(_this.sessionId, "/sample/").concat(sampleRefId), {
                  timeout: _this.requestTimeout
                }).then(function (r) {
                  return r.data;
                });

              case 2:
                res = _context9.sent;
                return _context9.abrupt("return", res);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x7) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setSample", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(sampleRefId, newSample) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _axios.default.patch("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                  patch: [{
                    op: "replace",
                    path: "/samples/".concat(sampleRefId),
                    value: newSample
                  }]
                }, {
                  timeout: _this.requestTimeout
                }).then(function (r) {
                  return r.data;
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x8, _x9) {
        return _ref11.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onUpdateAppConfig", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(appConfig) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this.url = appConfig["collaborationServer.url"] || defaultCollaborationServer;

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x10) {
        return _ref12.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setDataset", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(newUDT) {
        var latestDS, patch;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_this.sessionId) {
                  _context12.next = 6;
                  break;
                }

                _context12.next = 3;
                return _this.createNewSession(newUDT);

              case 3:
                _this.emit("dataset-reloaded");

                _context12.next = 12;
                break;

              case 6:
                _context12.next = 8;
                return _this.getDataset();

              case 8:
                latestDS = _context12.sent;
                patch = _rfc.default.createPatch(latestDS, newUDT);
                _context12.next = 12;
                return _axios.default.patch("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                  patch: patch
                });

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x11) {
        return _ref13.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getDataset", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      var fullDataset;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _axios.default.get("".concat(_this.url, "/api/session/").concat(_this.sessionId, "/download"), {
                timeout: _this.requestTimeout
              }).then(function (r) {
                return r.data;
              });

            case 2:
              fullDataset = _context13.sent;
              return _context13.abrupt("return", fullDataset);

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    })));

    _defineProperty(_assertThisInitialized(_this), "addSamples", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(newSamples) {
        var lastSampleIndex;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (_this.sessionId) {
                  _context14.next = 2;
                  break;
                }

                throw new Error("Not in a collaborative session");

              case 2:
                if (_this.ds) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 5;
                return _this.getSummary();

              case 5:
                lastSampleIndex = _this.ds.summary.samples.length;
                _context14.next = 8;
                return _axios.default.patch("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                  patch: newSamples.map(function (s, i) {
                    return {
                      op: "add",
                      path: "/samples/".concat(lastSampleIndex + i),
                      value: s
                    };
                  })
                }, {
                  timeout: _this.requestTimeout
                });

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x12) {
        return _ref15.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "removeSamples", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(sampleIds) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (_this.sessionId) {
                  _context15.next = 2;
                  break;
                }

                throw new Error("Not in a collaborative session");

              case 2:
                if (_this.ds) {
                  _context15.next = 5;
                  break;
                }

                _context15.next = 5;
                return _this.getSummary();

              case 5:
                _context15.next = 7;
                return _axios.default.patch("".concat(_this.url, "/api/session/").concat(_this.sessionId), {
                  patch: _this.ds.summary.samples.filter(function (s) {
                    return sampleIds.includes(s._id);
                  }).map(function (s) {
                    return {
                      op: "remove",
                      path: "/samples/".concat(s._id)
                    };
                  })
                }, {
                  timeout: _this.requestTimeout
                });

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x13) {
        return _ref16.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "isWritable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", true);

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    })));

    _this.url = (serverUrl || defaultCollaborationServer).trim().replace(/\/+$/, "");
    _this.currentlyLoadedSampleMap = {};
    return _this;
  }

  return CollaborativeDatasetManager;
}(_events.EventEmitter);

var _default = CollaborativeDatasetManager;
exports.default = _default;